<script>
import _ from 'lodash';

import { authComputed, authMethods, clientMethods, trainerComputed } from '@state/helpers';
import { breakpointsMixin } from '@mixins/breakpointsMixin';

export default {
  name: 'SignUpMobile',
  components: {},
  mixins: [breakpointsMixin],
  data() {
    return {
      email: '',
      password: '',
      authenticating: false,
    };
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    async handleSignUp() {
      this.authenticating = true;
      const signupData = {
        trainerId: this.myTrainer._id,
        email: this.currentUser.user.email,
        password: this.password,
      };

      const response = await this.signUp(signupData);

      if (response.status === 403) {
        console.error('HandleSignUp Error: ', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.user;
        this.setCurrentUser(updatedUser);

        this.$router.push('/home').catch((err) => {
          if (err !== undefined) {
            console.error(err);
          }
        });
      }

      this.authenticating = false;
    },
  },
  computed: {
    ...authComputed,
    ...trainerComputed,
    validTrainerId() {
      return this.myTrainer && this.myTrainer._id !== undefined;
    },
    validEmail() {
      return this.currentUser.user.email && this.currentUser.user.email !== undefined;
    },
  },
};
</script>

<template>
  <div :class="['container', { isMobile: !isDesktopView }]">
    <div class="header">
      <div class="title">
        <h1>Sign Up</h1>
      </div>
    </div>
    <div class="form">
      <form @submit.prevent="handleSignUp">
        <BaseInputText
          id="email"
          type="email"
          :disabled="true"
          classStyle="user"
          placeholder="Email"
          v-model="currentUser.user.email"
        />
        <BaseInputText
          id="password"
          autocomplete
          type="password"
          :disabled="!(myTrainer._id && currentUser.user.email)"
          classStyle="password"
          placeholder="Create Password"
          v-model="password"
        />
        <div class="to-sign-in">
          <p>
            Already have an account?
            <router-link class="btn-to-sign-in" to="/login">
              Sign In
            </router-link>
          </p>
        </div>
        <div class="signup-disabled" v-if="!(myTrainer._id && currentUser.user.email)">
          <h4>Signup Disabled...</h4>
          <pre v-if="!validTrainerId">•Valid TrainerId: {{ validTrainerId }}</pre>
          <pre v-if="!validEmail">•Valid Email: {{ validEmail }}</pre>
        </div>
        <div class="get-started">
          <BaseButton
            class="large"
            type="submit"
            :disabled="authenticating || !validTrainerId || !validEmail || password.length < 1"
          >
            <div v-if="authenticating === false">Get Started</div>
            <div v-else><b-spinner /></div>
          </BaseButton>
        </div>
      </form>
      <div class="other-info">
        <p>
          By signing up, you agree to the
          <a class="links" target="_blank" href="/privacy">Privacy Policy</a>
          and
          <a class="links" target="_blank" href="/terms">Terms of Use.</a>
        </p>
      </div>
    </div>
    <!-- <div class="form">
      <form action>
        <BaseInputText id="email" type="email" classStyle="user" placeholder="Email" v-model="email"></BaseInputText>
        <BaseInputText
          id="password"
          type="password"
          classStyle="password"
          placeholder="Create Password"
          v-model="password"
        ></BaseInputText>
        <div id="to-sign-in">
          <p>
            Already have an account?
            <router-link id="btn-forgot-password" to="/login">
              Sign In
            </router-link>
          </p>
        </div>
        <div id="sign-in">
          <BaseButton class="large">Sign Up</BaseButton>
        </div>
      </form>
    </div>
    <div id="other-info">
      <p>
        By logging in, you agree to the
        <router-link class="links" to="/">Privacy Policy</router-link> and
        <router-link class="links" to="/">Terms of Use.</router-link>
      </p>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;

    .title {
      align-self: center;
      font-family: $base-font-family;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin-bottom: 50px;
      margin-top: 30px;
    }
  }

  .form {
    background: white;
    width: 100%;

    form {
      align-items: center;
      display: flex;
      flex-direction: column;
      #email {
        margin-bottom: 5.4%;
        margin-top: 11.33%;
        width: 80%;
      }

      #password {
        width: 80%;
      }

      .signup-disabled {
        margin-top: 10px;
      }

      .to-sign-in {
        align-self: flex-end;
        font-family: $base-font-family;
        margin-bottom: 60px;
        text-align: end;
        width: 80%;

        .btn-to-sign-in {
          color: #4059e1;
          text-decoration: none;
        }
      }

      .get-started {
        width: 87.2%;

        button:disabled {
          background-color: lighten($color: #4059e1, $amount: 20);
        }
      }
      .input-wrapper {
        width: 100%;
        ::v-deep input {
          border-radius: unset;
          padding: 1.31% 5% 3.12% 14%;
          width: 100%;
          &.password {
            border-radius: unset;
            margin-bottom: 0.4rem;
          }
        }
      }
    }
  }

  .other-info {
    display: flex;
    height: 25%;
    justify-content: center;
    margin-top: 10px;
    width: 100%;

    p {
      font-family: $secondary-font-family;
      height: 100%;
      line-height: 1.4;
      text-align: center;
      width: 82%;

      .links {
        color: #4059e1;
        text-decoration: none;
      }
    }
  }
}
</style>
